//special order based on priority
export const specialOrder = [
  "all units",
  "studio",
  "1 bed",
  "2 bed",
  "3 bed",
  "4 bed",
  "vacant",
  "ntv",
  "all others",
];
//Orders special priority based on special order array
export const processSpecials = (special = [], specialOrder = []) => {
    try {
      if (
        !Array.isArray(specialOrder) ||
        !specialOrder.every((s) => typeof s === "string") ||
        !Array.isArray(special)
      ) {
        return special;
      }

      const orderMap = new Map(specialOrder.map((val, i) => [val, i]));

      const result = [];

      for (const item of special) {
        if (
          !item ||
          typeof item !== "object" ||
          !Array.isArray(item.unit_types)
        ) {
          console.log("Invalid entry skipped:", item);
          continue;
        }
        //If the units_types special is empty, push the current special and skip
        if(item.unit_types?.length === 0){
          result.push({
            ...item
          })
          continue;
        }

        for (const unit of item.unit_types) {
          if (typeof unit !== "string") continue;
          result.push({
            ...item,
            unit_types: [unit],
          });
        }
      }

      result.sort((a, b) => {
        const aIndex =
          orderMap.get(a.unit_types[0]?.toLowerCase()) ?? Number.POSITIVE_INFINITY;
        const bIndex =
          orderMap.get(b.unit_types[0]?.toLowerCase()) ?? Number.POSITIVE_INFINITY;
        return aIndex - bIndex;
      });

      return result;
    } catch (err) {
      console.log("Error processing special", err?.message);
      return special;
    }
}